// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"c590ab84","796":"572e3e19"}[chunkId] + ".chunk.js";
};